var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"incubatorPage"},[_c('LeftTree'),_c('RightContent',{staticStyle:{"width":"calc(100% - 300px)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }